import type { PrivilegeDefinition } from '@/core/be/security/SecurityTypes';
import type { FeatureModule } from '@/core/platform/features/FeatureModule';
import { AudioTranscriptionEnvConfig } from './core/AudioTranscriptionEnvConfig';

export const AudioPrivilegeIds = {
  transcribe: 'audio:transcribe',
} as const;

const AudioPrivileges: PrivilegeDefinition[] = [
  {
    id: AudioPrivilegeIds.transcribe,
    scope: 'vault', // Vault-scoped so roles can grant it
    feature: 'audio-transcription',
    description: 'Upload and transcribe audio.',
    subscriptionGated: true,
    subscriptionFeatureId: 'transcription',
    label: 'Audio Transcription',
  },
];

export class AudioTranscriptionFeatureModule {
  private static readonly definition: FeatureModule = {
    name: 'audio-transcription',
    envSchema: AudioTranscriptionEnvConfig.getSchema(),
    privileges: AudioPrivileges,
  };

  private constructor() {}

  public static getDefinition(): FeatureModule {
    return AudioTranscriptionFeatureModule.definition;
  }
}
